import React from 'react';
import { Card } from 'antd';
import TmpRunTaskRerunTab from './components/TmpRunTaskRerunTab';

const TmpRunTaskRerunPage: React.FC = () => {
  return (
    <Card title="tmp_run_task 重跑工具" bordered={false}>
      <TmpRunTaskRerunTab />
    </Card>
  );
};

export default TmpRunTaskRerunPage;
